import Widget from "components/widget/Widget";
import SearchField from "components/fields/SearchField";
import { IoIosCopy } from "react-icons/io";
import { MdNavigateNext, MdNavigateBefore, MdSkipPrevious, MdSkipNext } from "react-icons/md";
import { RiWallet3Fill } from "react-icons/ri";
import { PiAddressBookFill } from "react-icons/pi";
import { FaSackDollar } from "react-icons/fa6";
import { BsFillClockFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const AccountsBalance = () => {
  return (
    <div className="relative">
      {/* Card widget */}
      <div className="header-back-gradient">
        <div className="container">
          <div className="w-full flex items-center px-2.5 md:px-3 lg:px-5 py-6">
            <div className="md:flex justify-between w-full md:py-6">
              <p className="relative text-header text-white md:mb-0 mb-4">Account Balance</p>
              <SearchField
                extra="sm:min-w-[480px] xl:min-w-[650px]"
                placeholder="Search by Address/ Txn Hash/ Block/ Token/Domain Name"
                id="email"
                type="text"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="mt-6 md:mt-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden 2xl:px-[80px]">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 py-5 px-2.5 md:px-5 xl:px-[57px] gap-4">
              <Widget
                icon={<RiWallet3Fill className="h-7 w-7" />}
                title={"Top Account"}
                border="sm:border-r-[1px]"
                subtitle={<span className="text-green-600">Abc dEQ</span>}
              />
              <Widget
                icon={<PiAddressBookFill className="h-7 w-7" />}
                title={"Address"}
                border="lg:border-r-[1px]"
                subtitle={<span className="text-green-600">0x6d4C3166...903a5471</span>}
              />
              <Widget
                icon={<FaSackDollar className="h-7 w-7" />}
                title={"Balance"}
                border="sm:border-r-[1px]"
                subtitle={<span>541,658,457.35684 BBA</span>}
              />
              <Widget
                icon={<BsFillClockFill className="h-7 w-7" />}
                title={"Txn Count"}
                border="border-none"
                subtitle={<span>2,524</span>}
              />
            </div>
          </div>
        </div>
        <div className="mt-6 mb-12 px-2.5 md:px-3 lg:px-5">
          <div className="box bg-white dark:bg-darkPrimary overflow-hidden">
            <div className="flex flex-col mt-5 border-b-[1px] border-gray-100 dark:border-lightGrey 2xl:mx-[80px]">
              <div className="flex gap-1 flex-row items-center justify-between flex-wrap px-2.5 md:px-5 2xl:px-0 w-full py-4">
                <div className="not-italic text-large">
                Top Accounts by BBA Balance
                </div>
              </div>
            </div>
            <div className="table-wrapper">
              <table className="table w-full">
                <thead>
                  <tr className="border-none">
                    <th className="2xl:!pl-[80px]">Address</th>
                    <th className="">Account</th>
                    <th className="">Balance</th>
                    <th className="2xl:!pr-[80px]">Txn Count</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    Array(10).fill(0).map((data) => <tr>
                      <td className="2xl:!pl-[80px]">
                        <div className="flex gap-[1px] max-w-[160px]">
                          <div className="truncateWrapper">
                            <Link to="/address/0x95222290DD7278Aa3Ddd389Cc1E1d165CC4BAfe5 " className="text-green-900 text-small truncate">
                            0x95222290DD7278Aa3Ddd389Cc1E1d165CC4BAfe5 
                            </Link>
                          </div>
                          <button className="text-gray-700 dark:text-gray-300"><IoIosCopy /></button>
                        </div>
                      </td>
                      <td>
                        <p className="text-small text-green-900">Abc dEQ</p>
                      </td>
                      <td>
                        <p className="text-small">541,658,457.35684 BBA</p>
                      </td>
                      <td className="2xl:!pr-[80px]">
                        <p className="text-small">2,524</p>
                      </td>
                    </tr>)
                  }
                  
                </tbody>
              </table>
            </div>
            <div className="p-5 justify-center md:justify-between flex mb-2">
              <div className="md:flex gap-2 hidden">
                <span className="text-small flex items-center">Show</span>
                <select className="text-small">
                  <option>10</option>
                  <option>20</option>
                  <option>50</option>
                  <option>100</option>
                </select>
                <span className="text-small flex items-center">Per Page</span>
              </div>
              <div className="flex gap-2">
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdSkipPrevious /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl disabled"><MdNavigateBefore /></button>
                <span className="text-small flex items-center px-2">Page 1 of 25</span>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdNavigateNext /></button>
                <button className="!px-1.5 !py-1 btn-outline !text-xl"><MdSkipNext /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountsBalance;
